import { create } from 'zustand';
import { useMediaQuery } from '@mui/material';

const useStore = create((set) => ({

  chatId: "",
  setChatId: (data) => set({ chatId: data }),

  sidebarDiscussions: [],
  setSidebarDiscussion: (newDiscussions) => set({ sidebarDiscussions: newDiscussions || [] }),

  discussions: [], 
  setDiscussions: (newDiscussions) => set({ discussions: newDiscussions || [] }), 

  nonCommunityDiscussions: [],
  setNonCommunityDiscussions: (nonCommunityDiscussionsItems) => set({ nonCommunityDiscussions: nonCommunityDiscussionsItems || [] }),

  communities: [],
  setCommunities: (data) => set({ communities: data }),

  usersData: [],
  setUserData: (data) => set({ users: data }),

  discussionPressed: false,
  setDiscussionPressed: (data) => set({ discussionPressed: data }),

  currentCommunityId: "", // Default value as empty
  setCurrentCommunityId: (newCommunityId) => set({ currentCommunityId: newCommunityId || "" }), // Ensure newCommunity is never null

  currentDiscussionId: "",
  setCurrentDiscussionId: (newDiscussionId) => set({ currentDiscussionId: newDiscussionId || "" }),

  currentCommunityName: "", // Default value as empty
  setCurrentCommunityName: (newCommunityName) => set({ currentCommunityName: newCommunityName || "" }), // Ensure the community name is never null

  communitiesExpanded: false,
  setCommunitiesExpanded: (data) => set({ communitiesExpanded: data }),

  discussionExpanded: false,
  setDiscussionExpanded: (data) => set({ discussionExpanded: data }),

  mobileSidebarExpanded: false,
  setMobileSidebarExpanded: (data) => set({ mobileSidebarExpanded: data }),

  isHidden: 0,
  setIsHidden: (val) => set({ isHidden: val }),

  isLoggedIn: false,
  setIsLoggedIn: (val) => set({ isLoggedIn: val }),

  isCommunityAdmin: false,
  setIsCommunityAdmin: (val) => set({ isCommunityAdmin: val }),

  communityId: '',
  setCommunityId: (val) => set({ communityId: val }),

  subscriptionData: {},
  setSubscriptionData: (val) => set({ subscriptionData: val }),

  greenButtonSX: {
    fontWeight: 'bold', border: '1px solid black', borderRadius: '10px',            // 1. Glossy Gradient (Light Green to Primary Green)
    background: 'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(40, 165, 52, 0.5) 100%)',
    backgroundColor: 'rgba(129, 199, 132, 0.5)', // The "Lighter" base color

    // 2. Glassmorphism Effects
    backdropFilter: 'blur(4px)', // Softens the background behind the button
    border: '1px solid rgba(255, 255, 255, 0.3)', // Soft white border for depth

    // 3. Shadow for "Pop"
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

    // 4. Text Styling
    color: 'white', // Darker green text for readability
    fontWeight: 'bold',
    textTransform: 'uppercase',
    borderRadius: '12px',
    px: 0.2,
    py: 0.1,

    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(40, 165, 52, 0.4) 100%)',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    }
  }

}));

export default useStore;
